import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form, Modal, Button } from "react-bootstrap";
import {
  AuthService,
  EventService,
  EventApplicationService,
  GlobalSettingService,
} from "../../../services";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { injectModels } from "../../../redux/injectModels";
import { routes } from "../../../constants/routes";
import Editor from "react-simple-wysiwyg";
import { ApplicationType, EventStatus } from "../../../constants/Enum";
import { globalConstant } from "../../../constants/globalConstant";
import { handleConsoleError } from "../../../utils/common-methods";

const UnitModel = {
  id: null,
  userId: null,
  eventId: null,
  unitLength: null,
  unitWidth: null,
  unitTitle: null,
  description: null,
  amount: null,
  totalUnit: null,
  maxAllowed: null,
  refundable: false,
  isActive: false,
};

const CreateCatersPitch = (props) => {
  const { unitId } = useParams();
  const navigate = useNavigate();
  const [unitData, setUnitData] = useState({ ...UnitModel, maxAllowed: 1 });
  const loginUser = AuthService.getLoginUser();
  const { eventId } = useParams();
  const [amountLabel, setAmountLabel] = useState("Pitch Amount");
  const [appType, setAppType] = useState(0);
  const [commitmentFee, setCommitmentFee] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [reduceAmount, setReduceAmount] = useState("");
  const [error, setReduceError] = useState();
  const [isPublished, setPublished] = useState(true);
    const [statusLabels, setStatuslabel] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

    const getPitchStatusLables = async () => {
      try {
        const response = await GlobalSettingService.getPitchStatuslabels();
  
        if (response?.isSuccess && response?.data?.length > 0) {
          setStatuslabel(response?.data);
        }
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    };

  const gePitch = async () => {
    try {
      if (eventId) {
        await Promise.all([
          getEvent(eventId),
          getEventCateringApplications(eventId),
           getPitchStatusLables(),
        ]);
      }
      const res = (unitId && (await EventService.getUnitById(unitId))) || [];      
        const pitchMappedData = { ...UnitModel, ...res?.data };
        pitchMappedData.maxAllowed = 1;    
        reset(pitchMappedData);
        setUnitData(pitchMappedData);
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  useEffect(() => {
    gePitch();
  }, []);

  // Function to close the modal without saving
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const getEvent = async (eventId) => {
    const storedEvent = await EventService.getEventById(eventId);
    if (storedEvent && storedEvent.data) {
      const event = storedEvent.data;
      setPublished(unitId &&
        (event.eventStatusId === EventStatus.Published ||
          event.eventStatusId === EventStatus.InProgress ||
          event.eventStatusId === EventStatus.Completed)
      );
    }
  };

  const getEventCateringApplications = async (eventId) => {
    try {
      if (eventId) {
        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "C",
        );
        if (res?.isSuccess && res?.data && res?.data?.length > 0) {
          const appTypeTemp = res?.data?.[0]?.applicationType;
          setAppType(appTypeTemp);
          if (appTypeTemp === ApplicationType.Tender) {
            setAmountLabel("Minimum Bid");
          }
          if (appTypeTemp === ApplicationType.Turnover) {
            const response = await GlobalSettingService.getGlobalSettingList();

            if (response?.isSuccess && response?.data?.length > 0) {
              const minAmount = response?.data?.find(
                (item) =>
                  item.keyName.trim() ===
                  globalConstant.TURNOVER_COMMITMENT_FEE.trim(),
              );
              if (minAmount) {
                setCommitmentFee(minAmount?.keyValue);
              }
            }
            setAmountLabel("Commitment Fee");
          }
          if (appTypeTemp === ApplicationType.Bid) {
            setAmountLabel("Minimum Starting Bid");
          }
        }
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const onSubmit = async (data) => {
    try {
      if (
        appType === ApplicationType.Turnover &&
        parseFloat(data.amount) < commitmentFee
      ) {
        setError("amount", {
          message: `Please enter a commitment fee of £${commitmentFee} or more.`,
        });
        return;
      }
      let response = null;
      data.userId = loginUser?.id;
      data.eventId = eventId;
      data.description = unitData?.description;
      data.refundable = unitData?.refundable;
      data.isActive = unitData?.isActive;
      data.maxAllowed = unitData?.maxAllowed;

      props.application.setLoading(true);
      response = await EventService.CreateUnit(data);

      if (response?.isSuccess) {
        toast.success(response?.message);
        EventService.removePitchId();
        props.application.setLoading(false);
        navigate(routes.CATERS_ACCOUNT_PITCHES.replace(":eventId", eventId));
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
      toast.error(error?.message);
    }
  };
  const isNumberInRange = (value, min, max) => {
    console.log(value);
    if (value === "") return false;

    const regex = /^\d+(\.\d{0,2})?$/;
    const num = Number(value);
    console.log(regex.test(value));
    return regex.test(value) && !isNaN(num) && num > min && num < max;
  };

  const handleInputChange = (e) => {
    setReduceAmount(e.target.value);
    if (isNumberInRange(e.target.value, 0, unitData?.amount)) {
      //setReduceAmount(e.target.value);
      setReduceError("");
    } else {
      // setReduceAmount("");
      setReduceError(
        `Please enter an amount greater than 0 and less than ${unitData?.amount},with up to 2 decimal places.`,
      );
    }
  };
  const handleOpenModal = async (e) => {
    e.preventDefault();
    setReduceAmount(unitData?.amount);
    setShowModal(true);
  };

  const onReducePrice = async (e) => {
    try {
      e.preventDefault();
      if (!isNumberInRange(reduceAmount, 0, unitData?.amount)) {
        setReduceError(
          `Please enter an amount greater than 0 and less than ${unitData?.amount},with up to 2 decimal places.`,
        );
        return;
      } else {
        setReduceError("");
      }
      let data = {
        id: unitData.id,
        amount: reduceAmount,
      };
     props.application.setLoading(true);
      var response = await EventService.ReduceUnitPrice(data);

      if (response?.isSuccess) {
          EventService.removePitchId();
        props.application.setLoading(false);
        toast.success(response?.message);
      
        navigate(routes.CATERS_ACCOUNT_PITCHES.replace(":eventId", eventId));
      } else {
          props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
        props.application.setLoading(false);
      toast.error(error?.message);
    }
  };

  const handleChange = (e, cntName) => {
    //const name = "unitLength";
    let inputValue = e.target.value;
    // Remove all non-numeric characters except the decimal point
    inputValue = inputValue.replace(/[^0-9.]/g, "");

    // Ensure that only one decimal point is allowed
    inputValue = inputValue.replace(/(\..*?)\..*/g, "$1");

    // Update the state with the sanitized value
    // setValue(cntName, inputValue);
    setUnitData({ ...unitData, cntName: inputValue });

    const numericPattern = /^[+]?[0-9]*\.?[0-9]+$/; // Allows positive numbers, integers, and decimals

    // Validate if the value matches the numeric pattern and is greater than 0
    if (
      inputValue === "" ||
      (numericPattern.test(inputValue) && parseFloat(inputValue) > 0)
    ) {
      clearErrors(cntName); // Clear error message if input is valid
      if (
        cntName === "amount" &&
        appType === ApplicationType.Turnover &&
        parseFloat(inputValue) < commitmentFee
      ) {
        setError(cntName, {
          message: `Please enter a commitment fee of £${commitmentFee} or more.`,
        });
      }
    } else {
      setError(cntName, {
        message: "Please enter a valid numeric value greater than zero.",
      });
    }
  };

  const handleIsRefundable = (event) => {
    setUnitData({
      ...unitData,
      refundable: event.target.checked ? true : false,
    });
  };

  const handleIsStatus = (event) => {
    setUnitData({
      ...unitData,
      isActive: event.target.checked ? true : false,
    });
  };

  const handleDescription = (e) => {
    const val = e.target.value;
    setUnitData({
      ...unitData,
      description: val,
    });
  };

  return (
    <React.Fragment>
            {isPublished && <p className="text-danger mb-3"><strong>Note:: </strong>The pitch has been published. You can now updated the <strong>Display Status Label</strong> and <strong>Visibility Status.</strong></p>}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId="unitTitle" className="mb-3">
          <Form.Label>
            Pitch Title <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength={100}
            type="text"
            {...register("unitTitle", {
              required: "Please enter pitch title",
            })}
            defaultValue={unitData?.unitTitle}
             disabled={isPublished}
          />
          {errors.unitTitle && (
            <span className="text-danger">{errors.unitTitle?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="description" className="mb-3">
          <Form.Label>Description</Form.Label>
          <Editor value={unitData.description} onChange={handleDescription}  disabled={isPublished} />
          {errors.description && (
            <span className="text-danger">{errors.description?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="amount" className="mb-3">
          <Form.Label>
            {amountLabel} (£) <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength="10"
            type="text"
            defaultValue={unitData?.amount}
            {...register("amount", {
              required: `Please enter ${amountLabel?.toLowerCase()}`,
              pattern: {
                value: /^[+]?[0-9]*\.?[0-9]+$/,
                message: "Please enter a valid number greater than zero.",
              },
            })}
            onChange={(event) => handleChange(event, "amount")}
             disabled={isPublished}
          />
          {errors.amount && (
            <span className="text-danger">{errors.amount?.message}</span>
          )}
        </Form.Group>
        <Form.Group controlId="totalUnit" className="mb-3">
          <Form.Label>
            Total Available Pitches <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength="10"
            type="text"           
            defaultValue={unitData.totalUnit}
            {...register("totalUnit", {
              required: "Please enter available pitches",
              pattern: {
                value: /^[+]?[0-9]*\.?[0-9]+$/,
                message: "Please enter a valid number greater than zero.",
              },
            })}
            onChange={(event) => handleChange(event, "totalUnit")}
             disabled={isPublished}
          />
          {errors.totalUnit && (
            <span className="text-danger">{errors.totalUnit?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="maxAllowed" className="mb-3">
          <Form.Label>
            Maximum Individual Applications Allowed{" "}
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength="10"
            type="text"
            {...register("maxAllowed", {})}
            defaultValue={unitData.maxAllowed}
            disabled={true} // Disable the input field
            onChange={(event) => handleChange(event, "maxAllowed")}
            
          />
        </Form.Group>
        

        <Form.Group controlId="refundable" className="mb-3 custom-check">
          <Form.Label>Refundable</Form.Label>
          <Form.Check
            type="checkbox"
            defaultValue={unitData?.refundable}
            checked={unitData?.refundable} // Controlled by state
            onChange={handleIsRefundable} // Handle change event
             disabled={isPublished}
          />
        </Form.Group>

       <Form.Group controlId="statusLabel" className="mb-3">
          <Form.Label>Display Status Label</Form.Label>
           <Form.Select
                          {...register("statusLabel")}                         
                          defaultValue={unitData.statusLabel|| ""}
                        >                        
                  {statusLabels.map((sl) => (
                    <option key={sl?.id} value={sl?.value}>
                      {sl?.label}
                    </option>
                  ))}
                        </Form.Select>
        </Form.Group>
          <Form.Group controlId="refundable" className="mb-3 custom-check">
          <Form.Label>Visibility Status</Form.Label>
          <Form.Check
            type="checkbox"
            defaultValue={unitData?.isActive}
            checked={unitData?.isActive} // Controlled by state
            onChange={handleIsStatus} // Handle change event
          />
        </Form.Group>
       
        {/* {!isPublished && ( */}
        <button
          className="btn btn-primary mt-3"
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          Save
        </button>
        {/* )} */}
        {isPublished && unitData.id && (
          <button
            className="btn btn-primary mt-3 ms-3"
            type="button"
            onClick={(e) => handleOpenModal(e)}
          >
            Reduce Price
          </button>
        )}
      </Form>
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reduce Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Amount (£)</Form.Label>
              <Form.Control
                type="text"
                value={reduceAmount}
                onChange={handleInputChange}
                placeholder="Enter amount"
                maxLength={10}
              />
              {error && <Form.Text className="text-danger">{error}</Form.Text>}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={onReducePrice}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default injectModels(["application"])(CreateCatersPitch);
